import { em, math } from 'polished'
import styled, { css } from 'styled-components'

export const TooltipContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: opacity ${p => p.theme.animation.timeStandard} ease-in;
  z-index: 10;
  pointer-events: none;

  ${({ transitionState }) =>
    (transitionState === 'entered' || transitionState === 'entering') &&
    `opacity: 1;`}

  ${({ transitionState }) =>
    (transitionState === 'exited' || transitionState === 'exiting') &&
    `opacity: 0;`}

  ${p => p.theme.mq.upMd} {
    max-width: ${em(700)};
  }
`

export const TooltipInner = styled.div`
  position: relative;
  pointer-events: all;
`

export const TooltipContent = styled.div`
  background: ${p => p.theme.colors.black};
  color: ${p => p.theme.colors.white};
  border-radius: ${p => p.theme.blocks.blockBorderRadius};
  padding: ${p => em(p.theme.indents.baseIndentXs)};

  ${p => p.theme.mq.upMd} {
    padding: ${p => math(`${em(p.theme.indents.baseIndentMd)} / 2`)};

    ${({ withCloseIcon }) =>
      !!withCloseIcon &&
      `padding: ${p => math(`${p.theme.indents.baseBoxIndentLg} / 2`)};`}
  }
`

export const ButtonCloseWrapper = styled.div`
  position: absolute;
  right: ${em(5)};
  top: ${em(5)};

  ${p => p.theme.mq.upMd} {
    right: ${em(15)};
    top: ${em(15)};
  }
`

const arrowStyles = {
  down: css`
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${p => p.theme.colors.black};
    bottom: 0;
    transform: translate(-50%, 100%);
  `,
  up: css`
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${p => p.theme.colors.black};
    top: 0;
    transform: translate(-50%, -100%);
  `,
  left: css`
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    top: 0;
    border-right: 10px solid ${p => p.theme.colors.black};
    left: 0;
    transform: translate(-100%, -50%);
  `,
  right: css`
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    top: 0;
    border-left: 10px solid ${p => p.theme.colors.black};
    right: 0;
    transform: translate(100%, -50%);
  `,
}

export const TooltipArrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;

  ${({ position }) => arrowStyles[position]}
`
